import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class FactoryRushCapacityProductGroupMember
  implements MutableValue {
  public isNew = true;

  constructor(private fProduct: string, private fProductGroup: string) {
    [fProduct, fProductGroup].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fProduct;
  }

  get product(): string {
    return this.fProduct;
  }

  get productGroup(): string {
    return this.fProductGroup;
  }
}
